import { render, staticRenderFns } from "./proUseDetails.vue?vue&type=template&id=70011ed6&scoped=true"
import script from "./proUseDetails.vue?vue&type=script&lang=js"
export * from "./proUseDetails.vue?vue&type=script&lang=js"
import style0 from "./proUseDetails.vue?vue&type=style&index=0&id=70011ed6&prod&lang=scss&scoped=true"
import style1 from "./proUseDetails.vue?vue&type=style&index=1&id=70011ed6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70011ed6",
  null
  
)

export default component.exports